var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b8bfeee67fc629e3f88e4f15cf230548164029f8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["everest@noissue"]={id:"b8bfeee67fc629e3f88e4f15cf230548164029f8"};
      